export default "d4ba41843b4d173b.svg"